import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(theme => ({
   linkRoleToOperationContainer: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
   },
   namebar: {
      width: '100%',
      paddingTop: theme.spacing(1),
      paddingLeft: theme.spacing(2),
      height: 39,
      marginBottom: theme.spacing(0.5)
   },
   title: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: 16,
      lineHeight: '20px',
      letterSpacing: '-0.05px',
      color: '#3A3B3F',
      width: 200,
      textAlign: 'left'
   },
   line: {
      backgroundColor: '#3264DC',
      height: '3px',
      marginBottom: 0,
      marginTop: theme.spacing(0.5),
      width: 192
   },
   content: {
      flex: 1,
      width: '100%',
      padding: theme.spacing(0.5, 2, 0)
   },
   button: {
      width: 230,
      marginLeft: theme.spacing(2.5),
      height: 40,
      float: 'right'
   },
   buttonsContainer: {
      width: '100%',
      height: '40px',
      paddingRight: theme.spacing(2.5),
      marginTop: theme.spacing(3)
   }
}))